import { styled } from 'next-yak'

import * as colors from '../constants/colors'
import * as copy from './copy'

export type ProgressBarProps = {
  $min?: number
  $max?: number
  $value: number
}

export const ProgressBar = styled.div.attrs<ProgressBarProps>((props) => ({
  role: 'progressbar',
  'aria-valuemin': props.$min ?? 0,
  'aria-valuemax': props.$max ?? 100,
  'aria-valuenow': props.$value,
}))<ProgressBarProps>`
  height: 8px;
  background-color: ${colors.PRIMARY_SAND_100};
  border-radius: 8px;
  position: relative;

  &::before {
    content: '';
    border-radius: 8px;
    background-color: ${({ $value }) => ($value >= 100 ? colors.SECONDARY_GREEN_500 : colors.PRIMARY_BLUE_500)};
    display: block;
    position: absolute;
    left: 0;
    width: max(8px, ${({ $value }) => $value}%);
    top: 0;
    bottom: 0;
  }
`

export const ProgressBarContainer = styled.div`
  position: relative;
  max-width: 488px;
  width: 100%;
  background-color: transparent;
  border-radius: 100px;
  height: 8px;
  margin-bottom: 22px;

  ${ProgressBar}::before {
    background-color: ${(props) => (props.theme as any)?.colors?.primary ?? colors.PRIMARY_BLUE_500};
    transition: width 500ms ease-in-out;
  }
`

export const ProgressBarText = styled(copy.S.semiBold)`
  position: absolute;
  top: 16px;
  right: 4px;
  color: ${(props) => (props.theme as any)?.colors?.primary ?? colors.PRIMARY_BLUE_500};
  white-space: nowrap;
  padding: 0;

  span {
    color: ${colors.PRIMARY_SAND_700};
    font-weight: inherit;

    span {
      font-weight: 400; // HACK: Irregular font manipulation
    }
  }
`
